import React from 'react';
import { ArrowLeftIcon, CheckCircleIcon, XIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
import { RestaurantProfitCalculator } from '../components/RestaurantProfitCalculator';
export function RestaurantsPage() {
  return <div className="min-h-screen bg-white" data-id="element-495">
      {/* Header */}
      <div className="py-20 md:py-32" style={{
      backgroundColor: '#1a2332'
    }} data-id="element-496">
        <div className="container mx-auto px-4 md:px-6 lg:px-12" data-id="element-497">
          <Link to="/" className="inline-flex items-center gap-2 text-sm text-gray-300 hover:text-white mb-8 transition-colors" data-id="element-498">
            <ArrowLeftIcon size={16} data-id="element-499" />
            Back to Home
          </Link>
          <h1 className="text-4xl md:text-7xl font-light mb-6 text-white" data-id="element-500">
            WELLHAUS™
          </h1>
          <p className="text-xl md:text-2xl text-gray-300 font-light max-w-3xl mb-8" data-id="element-501">
            Premium Water, Elevated Experience
          </p>
          <p className="text-lg text-gray-400 max-w-3xl mb-8" data-id="element-502">
            Still Alkaline • Sparkling Mineral (Pellegrino-Style) • Hot Alkaline
          </p>
          <p className="text-base text-gray-300 max-w-3xl mb-10" data-id="element-503">
            WELLHAUS™ delivers unmatched purity, modern design, and
            industry-first water technology for restaurants, hotels, cafés,
            spas, and corporate environments.
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4" data-id="element-504">
            <a href="https://form.typeform.com/to/rfYM00cT" target="_blank" rel="noopener noreferrer" className="px-10 py-4 bg-white text-gray-900 text-base font-medium rounded-full hover:bg-gray-100 transition-colors text-center" data-id="element-505">
              Request a Demo
            </a>
            <a href="https://calendly.com/-smartsoda/discoverycall" target="_blank" rel="noopener noreferrer" className="px-10 py-4 border border-white text-white text-base font-medium rounded-full hover:bg-white hover:text-gray-900 transition-colors text-center" data-id="element-506">
              Contact Sales
            </a>
          </div>
        </div>
      </div>

      {/* Hero Image */}
      <div className="relative h-[400px] md:h-[600px]" data-id="element-507">
        <img src="https://cdn.magicpatterns.com/uploads/kZhkMRPEbMaCr8wQW33oKv/Wellhaus_Restaurant_.webp" alt="WELLHAUS Drinkstation in fine dining restaurant" className="w-full h-full object-cover" data-id="element-508" />
        <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent" data-id="element-509" />
      </div>

      {/* Why WELLHAUS Section */}
      <div className="py-20 md:py-32 bg-white" data-id="element-510">
        <div className="container mx-auto px-4 md:px-6 lg:px-12" data-id="element-511">
          <div className="max-w-4xl mx-auto text-center mb-16" data-id="element-512">
            <h2 className="text-4xl md:text-6xl font-light mb-6" data-id="element-513">
              Why WELLHAUS™
            </h2>
            <p className="text-xl text-gray-600 leading-relaxed" data-id="element-514">
              WELLHAUS is built for venues that demand the highest standards in
              water quality, culinary performance, guest experience, and
              sustainability.
            </p>
          </div>
        </div>
      </div>

      {/* Exclusive Smart Soda Advantages */}
      <div className="py-20 md:py-32 bg-gray-50" data-id="element-515">
        <div className="container mx-auto px-4 md:px-6 lg:px-12" data-id="element-516">
          <div className="max-w-4xl mx-auto" data-id="element-517">
            <h2 className="text-4xl md:text-6xl font-light mb-12 text-center" data-id="element-518">
              Exclusive WELLHAUS™ Advantages
            </h2>
            <p className="text-xl text-gray-600 text-center mb-12" data-id="element-519">
              WELLHAUS™ is the ONLY company that offers:
            </p>

            <div className="grid md:grid-cols-2 gap-6" data-id="element-520">
              <div className="bg-white p-8 rounded-2xl shadow-lg" data-id="element-521">
                <h3 className="text-2xl font-light mb-4" data-id="element-522">
                  Still Alkaline Water
                </h3>
                <p className="text-gray-600" data-id="element-523">
                  Pure, balanced pH for everyday wellbeing and superior taste.
                </p>
              </div>
              <div className="bg-white p-8 rounded-2xl shadow-lg" data-id="element-524">
                <h3 className="text-2xl font-light mb-4" data-id="element-525">
                  Sparkling Mineral Water
                </h3>
                <p className="text-gray-600" data-id="element-526">
                  Pellegrino-style sparkling mineral water, uniquely made from
                  alkaline water.
                </p>
              </div>
              <div className="bg-white p-8 rounded-2xl shadow-lg" data-id="element-527">
                <h3 className="text-2xl font-light mb-4" data-id="element-528">
                  Ambient Alkaline Water
                </h3>
                <p className="text-gray-600" data-id="element-529">
                  Room temperature alkaline water for culinary applications.
                </p>
              </div>
              <div className="bg-white p-8 rounded-2xl shadow-lg" data-id="element-530">
                <h3 className="text-2xl font-light mb-4" data-id="element-531">
                  Custom-Branded Bottle Printing
                </h3>
                <p className="text-gray-600" data-id="element-532">
                  Full custom bottle printing for your brand identity.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Why Sparkling Mineral Water Matters */}
      <div className="py-20 md:py-32 bg-white" data-id="element-533">
        <div className="container mx-auto px-4 md:px-6 lg:px-12" data-id="element-534">
          <div className="max-w-4xl mx-auto" data-id="element-535">
            <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-536">
              <div data-id="element-537">
                <h2 className="text-3xl md:text-5xl font-light mb-6" data-id="element-538">
                  Why Sparkling Mineral Water Matters
                </h2>
                <p className="text-lg text-gray-600 leading-relaxed mb-6" data-id="element-539">
                  WELLHAUS™'s Sparkling Mineral Water is made from alkaline
                  water — not acidic RO water.
                </p>
                <div className="space-y-4 mb-6" data-id="element-540">
                  <div className="flex items-start gap-3" data-id="element-541">
                    <CheckCircleIcon size={20} className="flex-shrink-0 text-water-accent mt-1" data-id="element-542" />
                    <div data-id="element-543">
                      <p className="font-medium text-gray-900" data-id="element-544">Less Acidic</p>
                      <p className="text-sm text-gray-600" data-id="element-545">
                        Gentler on the palate and digestive system
                      </p>
                    </div>
                  </div>
                  <div className="flex items-start gap-3" data-id="element-546">
                    <CheckCircleIcon size={20} className="flex-shrink-0 text-water-accent mt-1" data-id="element-547" />
                    <div data-id="element-548">
                      <p className="font-medium text-gray-900" data-id="element-549">Silkier</p>
                      <p className="text-sm text-gray-600" data-id="element-550">
                        Smoother mouthfeel and texture
                      </p>
                    </div>
                  </div>
                  <div className="flex items-start gap-3" data-id="element-551">
                    <CheckCircleIcon size={20} className="flex-shrink-0 text-water-accent mt-1" data-id="element-552" />
                    <div data-id="element-553">
                      <p className="font-medium text-gray-900" data-id="element-554">Healthier</p>
                      <p className="text-sm text-gray-600" data-id="element-555">
                        Balanced pH supports overall wellness
                      </p>
                    </div>
                  </div>
                  <div className="flex items-start gap-3" data-id="element-556">
                    <CheckCircleIcon size={20} className="flex-shrink-0 text-water-accent mt-1" data-id="element-557" />
                    <div data-id="element-558">
                      <p className="font-medium text-gray-900" data-id="element-559">
                        Fresher and Cleaner
                      </p>
                      <p className="text-sm text-gray-600" data-id="element-560">
                        On-demand production ensures peak freshness
                      </p>
                    </div>
                  </div>
                </div>
                <p className="text-base text-gray-700 italic" data-id="element-561">
                  Taste profile similar to Pellegrino/Acqua Panna, but cleaner.
                  No competitor can replicate this.
                </p>
              </div>
              <div className="relative h-[400px] rounded-2xl overflow-hidden shadow-2xl" data-id="element-562">
                <img src="https://cdn.magicpatterns.com/uploads/rQWcL2dcjXTY7LtHPtBanm/WATER-VINCI-v2-2025-01.931_(1).webp" alt="WELLHAUS Drinkstation control panel" className="w-full h-full object-cover" data-id="element-563" />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Perfect For */}
      <div className="py-20 md:py-32 bg-gray-50" data-id="element-564">
        <div className="container mx-auto px-4 md:px-6 lg:px-12" data-id="element-565">
          <div className="max-w-4xl mx-auto" data-id="element-566">
            <h2 className="text-4xl md:text-6xl font-light mb-12 text-center" data-id="element-567">
              Perfect For
            </h2>
            <div className="grid md:grid-cols-2 gap-4" data-id="element-568">
              <div className="bg-white p-6 rounded-xl" data-id="element-569">
                <p className="text-lg text-gray-700" data-id="element-570">
                  Premium restaurants & cafés
                </p>
              </div>
              <div className="bg-white p-6 rounded-xl" data-id="element-571">
                <p className="text-lg text-gray-700" data-id="element-572">
                  Hotels, resorts, lounges & spas
                </p>
              </div>
              <div className="bg-white p-6 rounded-xl" data-id="element-573">
                <p className="text-lg text-gray-700" data-id="element-574">
                  Corporate dining & conference centers
                </p>
              </div>
              <div className="bg-white p-6 rounded-xl" data-id="element-575">
                <p className="text-lg text-gray-700" data-id="element-576">
                  Co-working & hospitality suites
                </p>
              </div>
              <div className="bg-white p-6 rounded-xl" data-id="element-577">
                <p className="text-lg text-gray-700" data-id="element-578">Wellness clubs</p>
              </div>
              <div className="bg-white p-6 rounded-xl" data-id="element-579">
                <p className="text-lg text-gray-700" data-id="element-580">Bars & event spaces</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Culinary & Beverage Advantages */}
      <div className="py-20 md:py-32 bg-white" data-id="element-581">
        <div className="container mx-auto px-4 md:px-6 lg:px-12" data-id="element-582">
          <div className="max-w-4xl mx-auto" data-id="element-583">
            <h2 className="text-4xl md:text-6xl font-light mb-12 text-center" data-id="element-584">
              Culinary & Beverage Advantages
            </h2>

            <div className="grid md:grid-cols-2 gap-12 mb-12" data-id="element-585">
              <div data-id="element-586">
                <h3 className="text-2xl font-light mb-6" data-id="element-587">
                  Back-of-House (Culinary)
                </h3>
                <ul className="space-y-3 text-gray-700" data-id="element-588">
                  <li className="flex items-start gap-3" data-id="element-589">
                    <span className="flex-shrink-0 w-1.5 h-1.5 rounded-full bg-water-accent mt-2" data-id="element-590" />
                    <span data-id="element-591">Cooking, baking, doughs, breads, pasta</span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-592">
                    <span className="flex-shrink-0 w-1.5 h-1.5 rounded-full bg-water-accent mt-2" data-id="element-593" />
                    <span data-id="element-594">Soups, sauces, reductions</span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-595">
                    <span className="flex-shrink-0 w-1.5 h-1.5 rounded-full bg-water-accent mt-2" data-id="element-596" />
                    <span data-id="element-597">
                      Coffee & espresso (better extraction, less acidity)
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-598">
                    <span className="flex-shrink-0 w-1.5 h-1.5 rounded-full bg-water-accent mt-2" data-id="element-599" />
                    <span data-id="element-600">Tea & infusions</span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-601">
                    <span className="flex-shrink-0 w-1.5 h-1.5 rounded-full bg-water-accent mt-2" data-id="element-602" />
                    <span data-id="element-603">Ice machines — clearer, harder ice</span>
                  </li>
                </ul>
              </div>

              <div data-id="element-604">
                <h3 className="text-2xl font-light mb-6" data-id="element-605">Front-of-House</h3>
                <ul className="space-y-3 text-gray-700" data-id="element-606">
                  <li className="flex items-start gap-3" data-id="element-607">
                    <span className="flex-shrink-0 w-1.5 h-1.5 rounded-full bg-water-accent mt-2" data-id="element-608" />
                    <span data-id="element-609">Still, Sparkling & Sparkling Mineral</span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-610">
                    <span className="flex-shrink-0 w-1.5 h-1.5 rounded-full bg-water-accent mt-2" data-id="element-611" />
                    <span data-id="element-612">Alkaline water service</span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-613">
                    <span className="flex-shrink-0 w-1.5 h-1.5 rounded-full bg-water-accent mt-2" data-id="element-614" />
                    <span data-id="element-615">
                      Menu integration ("Still • Sparkling • Sparkling Mineral •
                      Alkaline")
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-616">
                    <span className="flex-shrink-0 w-1.5 h-1.5 rounded-full bg-water-accent mt-2" data-id="element-617" />
                    <span data-id="element-618">Custom-branded bottle service</span>
                  </li>
                </ul>
              </div>
            </div>

            <div className="relative h-[400px] rounded-2xl overflow-hidden shadow-2xl" data-id="element-619">
              <img src="https://cdn.magicpatterns.com/uploads/iKwAGq8krtX1SRnrGw74t4/Culinary__Beverage_Advantages.webp" alt="WELLHAUS Drinkstation in fine dining restaurant" className="w-full h-full object-cover" data-id="element-620" />
            </div>
          </div>
        </div>
      </div>

      {/* Custom Bottle Printing */}
      <div className="py-20 md:py-32 bg-gray-50" data-id="element-621">
        <div className="container mx-auto px-4 md:px-6 lg:px-12" data-id="element-622">
          <div className="max-w-4xl mx-auto" data-id="element-623">
            <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-624">
              <div className="order-2 md:order-1 relative h-[400px] rounded-2xl overflow-hidden shadow-2xl" data-id="element-625">
                <img src="https://cdn.magicpatterns.com/uploads/wvpp54LGRTQnDaudMGriSh/Bottle.webp" alt="Custom branded WELLHAUS bottle" className="w-full h-full object-cover" data-id="element-626" />
              </div>
              <div className="order-1 md:order-2" data-id="element-627">
                <h2 className="text-3xl md:text-5xl font-light mb-6" data-id="element-628">
                  Custom Bottle Printing
                </h2>
                <p className="text-lg text-gray-600 leading-relaxed mb-6" data-id="element-629">
                  Exclusive full custom bottle printing:
                </p>
                <ul className="space-y-3 text-gray-700 mb-6" data-id="element-630">
                  <li className="flex items-start gap-3" data-id="element-631">
                    <span className="flex-shrink-0 w-1.5 h-1.5 rounded-full bg-water-accent mt-2" data-id="element-632" />
                    <span data-id="element-633">Reusable/glass bottles</span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-634">
                    <span className="flex-shrink-0 w-1.5 h-1.5 rounded-full bg-water-accent mt-2" data-id="element-635" />
                    <span data-id="element-636">Restaurant, hotel, VIP, and event branding</span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-637">
                    <span className="flex-shrink-0 w-1.5 h-1.5 rounded-full bg-water-accent mt-2" data-id="element-638" />
                    <span data-id="element-639">Wellness-themed designs</span>
                  </li>
                </ul>
                <p className="text-base text-gray-700 font-medium" data-id="element-640">
                  Benefits: higher check averages, luxury presentation,
                  eco-friendly service.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Technology & Performance */}
      <div className="py-20 md:py-32 bg-white" data-id="element-641">
        <div className="container mx-auto px-4 md:px-6 lg:px-12" data-id="element-642">
          <div className="max-w-4xl mx-auto" data-id="element-643">
            <h2 className="text-4xl md:text-6xl font-light mb-12 text-center" data-id="element-644">
              Technology & Performance
            </h2>
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-645">
              <div className="bg-gray-50 p-6 rounded-xl" data-id="element-646">
                <p className="text-gray-700" data-id="element-647">Multi-stage advanced filtration</p>
              </div>
              <div className="bg-gray-50 p-6 rounded-xl" data-id="element-648">
                <p className="text-gray-700" data-id="element-649">
                  Stainless steel internal architecture
                </p>
              </div>
              <div className="bg-gray-50 p-6 rounded-xl" data-id="element-650">
                <p className="text-gray-700" data-id="element-651">High-capacity chilling</p>
              </div>
              <div className="bg-gray-50 p-6 rounded-xl" data-id="element-652">
                <p className="text-gray-700" data-id="element-653">AI diagnostics</p>
              </div>
              <div className="bg-gray-50 p-6 rounded-xl" data-id="element-654">
                <p className="text-gray-700" data-id="element-655">Automatic cleaning cycles</p>
              </div>
              <div className="bg-gray-50 p-6 rounded-xl" data-id="element-656">
                <p className="text-gray-700" data-id="element-657">
                  Consistent carbonation & mineral dosing
                </p>
              </div>
              <div className="bg-gray-50 p-6 rounded-xl" data-id="element-658">
                <p className="text-gray-700" data-id="element-659">110V standard</p>
              </div>
              <div className="bg-gray-50 p-6 rounded-xl" data-id="element-660">
                <p className="text-gray-700" data-id="element-661">Countertop models</p>
              </div>
              <div className="bg-gray-50 p-6 rounded-xl" data-id="element-662">
                <p className="text-gray-700" data-id="element-663">
                  Under-counter & free-standing options
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Sustainability */}
      <div className="py-20 md:py-32 bg-gray-50" data-id="element-664">
        <div className="container mx-auto px-4 md:px-6 lg:px-12" data-id="element-665">
          <div className="max-w-4xl mx-auto" data-id="element-666">
            <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-667">
              <div data-id="element-668">
                <h2 className="text-3xl md:text-5xl font-light mb-6" data-id="element-669">
                  Sustainability
                </h2>
                <p className="text-lg text-gray-600 leading-relaxed mb-6" data-id="element-670">
                  WELLHAUS reduces:
                </p>
                <ul className="space-y-3 text-gray-700 mb-6" data-id="element-671">
                  <li className="flex items-start gap-3" data-id="element-672">
                    <span className="flex-shrink-0 w-1.5 h-1.5 rounded-full bg-water-accent mt-2" data-id="element-673" />
                    <span data-id="element-674">Plastic bottles</span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-675">
                    <span className="flex-shrink-0 w-1.5 h-1.5 rounded-full bg-water-accent mt-2" data-id="element-676" />
                    <span data-id="element-677">Pallet deliveries</span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-678">
                    <span className="flex-shrink-0 w-1.5 h-1.5 rounded-full bg-water-accent mt-2" data-id="element-679" />
                    <span data-id="element-680">Cold storage</span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-681">
                    <span className="flex-shrink-0 w-1.5 h-1.5 rounded-full bg-water-accent mt-2" data-id="element-682" />
                    <span data-id="element-683">Recycling waste</span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-684">
                    <span className="flex-shrink-0 w-1.5 h-1.5 rounded-full bg-water-accent mt-2" data-id="element-685" />
                    <span data-id="element-686">Carbon footprint</span>
                  </li>
                </ul>
                <p className="text-xl text-gray-900 font-medium" data-id="element-687">
                  Up to 90% plastic reduction per location.
                </p>
              </div>
              <div className="relative h-[400px] rounded-2xl overflow-hidden shadow-2xl" data-id="element-688">
                <img src="https://images.unsplash.com/photo-1542601906990-b4d3fb778b09?w=800&q=80" alt="Sustainability" className="w-full h-full object-cover" data-id="element-689" />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Pricing */}
      <div className="py-20 md:py-32 bg-white" data-id="element-690">
        <div className="container mx-auto px-4 md:px-6 lg:px-12" data-id="element-691">
          <div className="max-w-4xl mx-auto" data-id="element-692">
            <h2 className="text-4xl md:text-6xl font-light mb-12 text-center" data-id="element-693">
              WELLHAUS™ Subscription Pricing
            </h2>

            <div className="bg-gradient-to-br from-gray-900 to-gray-800 rounded-2xl p-8 md:p-12 text-white mb-8" data-id="element-694">
              <div className="text-center mb-8" data-id="element-695">
                <p className="text-5xl md:text-6xl font-light mb-2" data-id="element-696">
                  $350<span className="text-2xl text-gray-300" data-id="element-697">/month</span>
                </p>
                <p className="text-lg text-gray-300" data-id="element-698">Monthly Cost</p>
              </div>

              <div className="space-y-4" data-id="element-699">
                <div className="flex items-center justify-between py-3 border-b border-gray-700" data-id="element-700">
                  <span className="text-gray-200" data-id="element-701">The WELLHAUS™ System</span>
                  <span className="text-white font-medium" data-id="element-702">Included</span>
                </div>
                <div className="flex items-center justify-between py-3 border-b border-gray-700" data-id="element-703">
                  <span className="text-gray-200" data-id="element-704">Installation & Delivery</span>
                  <span className="text-white font-medium" data-id="element-705">Included</span>
                </div>
                <div className="flex items-center justify-between py-3 border-b border-gray-700" data-id="element-706">
                  <span className="text-gray-200" data-id="element-707">Lease to Own</span>
                  <span className="text-white font-medium" data-id="element-708">Included</span>
                </div>
                <div className="flex items-center justify-between py-3 border-b border-gray-700" data-id="element-709">
                  <span className="text-gray-200" data-id="element-710">$0 Down Payment</span>
                  <span className="text-white font-medium" data-id="element-711">Included</span>
                </div>
                <div className="flex items-center justify-between py-3 border-b border-gray-700" data-id="element-712">
                  <span className="text-gray-200" data-id="element-713">
                    Unlimited Alkaline Water
                  </span>
                  <span className="text-white font-medium" data-id="element-714">Included</span>
                </div>
                <div className="flex items-center justify-between py-3 border-b border-gray-700" data-id="element-715">
                  <span className="text-gray-200" data-id="element-716">
                    120 Customized 1L Bottles
                  </span>
                  <span className="text-white font-medium" data-id="element-717">Included</span>
                </div>
                <div className="flex items-center justify-between py-3 border-b border-gray-700" data-id="element-718">
                  <span className="text-gray-200" data-id="element-719">Service & Maintenance</span>
                  <span className="text-white font-medium" data-id="element-720">Included</span>
                </div>
                <div className="flex items-center justify-between py-3" data-id="element-721">
                  <span className="text-gray-200" data-id="element-722">
                    Listing on the WELLHAUS™ App
                  </span>
                  <span className="text-white font-medium" data-id="element-723">Included</span>
                </div>
              </div>
            </div>

            <div className="bg-green-50 border-2 border-green-200 rounded-xl p-6 mb-6" data-id="element-724">
              <div className="flex items-start gap-3" data-id="element-725">
                <span className="text-green-600 text-xl" data-id="element-726">✔</span>
                <div data-id="element-727">
                  <p className="font-medium text-gray-900 mb-1" data-id="element-728">
                    Tax Advantage
                  </p>
                  <p className="text-sm text-gray-700" data-id="element-729">
                    Eligible for IRS Section 179 — up to 100% deductible in the
                    year of use
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-gray-50 rounded-xl p-6" data-id="element-730">
              <div className="flex items-start gap-3" data-id="element-731">
                <span className="text-gray-600 text-xl" data-id="element-732">✔</span>
                <div data-id="element-733">
                  <p className="font-medium text-gray-900 mb-1" data-id="element-734">Disclaimer</p>
                  <p className="text-sm text-gray-600" data-id="element-735">
                    Pricing subject to credit approval, availability, and
                    applicable tax laws.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* IRS Section 179 Benefit */}
      <div className="py-20 md:py-32 bg-gray-50" data-id="element-736">
        <div className="container mx-auto px-4 md:px-6 lg:px-12" data-id="element-737">
          <div className="max-w-4xl mx-auto" data-id="element-738">
            <h2 className="text-4xl md:text-6xl font-light mb-12 text-center" data-id="element-739">
              IRS Section 179 Benefit
            </h2>
            <p className="text-xl text-gray-600 text-center mb-12" data-id="element-740">
              WELLHAUS leases are 100% Section 179 deductible.
            </p>

            <div className="grid md:grid-cols-2 gap-6" data-id="element-741">
              <div className="bg-white p-8 rounded-xl shadow-lg" data-id="element-742">
                <h3 className="text-xl font-medium mb-3" data-id="element-743">
                  Lower Taxable Income
                </h3>
                <p className="text-gray-600" data-id="element-744">
                  Deduct the full lease amount from your taxable income
                </p>
              </div>
              <div className="bg-white p-8 rounded-xl shadow-lg" data-id="element-745">
                <h3 className="text-xl font-medium mb-3" data-id="element-746">Better Cash Flow</h3>
                <p className="text-gray-600" data-id="element-747">
                  Preserve capital while upgrading equipment
                </p>
              </div>
              <div className="bg-white p-8 rounded-xl shadow-lg" data-id="element-748">
                <h3 className="text-xl font-medium mb-3" data-id="element-749">
                  Reduced Cost of Ownership
                </h3>
                <p className="text-gray-600" data-id="element-750">
                  Tax benefits lower your effective monthly cost
                </p>
              </div>
              <div className="bg-white p-8 rounded-xl shadow-lg" data-id="element-751">
                <h3 className="text-xl font-medium mb-3" data-id="element-752">Faster ROI</h3>
                <p className="text-gray-600" data-id="element-753">
                  Tax savings accelerate return on investment
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Competitive Comparison Table */}
      <div className="py-20 md:py-32 bg-white" data-id="element-754">
        <div className="container mx-auto px-4 md:px-6 lg:px-12" data-id="element-755">
          <div className="max-w-5xl mx-auto" data-id="element-756">
            <h2 className="text-4xl md:text-6xl font-light mb-12 text-center" data-id="element-757">
              Competitive Comparison
            </h2>

            <div className="overflow-x-auto" data-id="element-758">
              <table className="w-full border-collapse" data-id="element-759">
                <thead data-id="element-760">
                  <tr className="bg-gray-900 text-white" data-id="element-761">
                    <th className="text-left p-4 font-medium text-base" data-id="element-762">
                      Feature
                    </th>
                    <th className="text-center p-4 font-medium text-base" data-id="element-763">
                      WELLHAUS™
                    </th>
                    <th className="text-center p-4 font-medium text-base" data-id="element-764">
                      Competitors
                    </th>
                  </tr>
                </thead>
                <tbody data-id="element-765">
                  <tr className="border-b border-gray-200" data-id="element-766">
                    <td className="p-4 text-base text-gray-900" data-id="element-767">
                      Alkaline Water
                    </td>
                    <td className="p-4 text-center text-base text-gray-900" data-id="element-768">
                      <CheckCircleIcon className="inline text-green-600" size={20} data-id="element-769" />{' '}
                      <span className="text-base text-water-accent" data-id="element-770">
                        Exclusive
                      </span>
                    </td>
                    <td className="p-4 text-center text-base text-gray-900" data-id="element-771">
                      Regular/Acidic
                    </td>
                  </tr>
                  <tr className="border-b border-gray-200 bg-gray-50" data-id="element-772">
                    <td className="p-4 text-base text-gray-900" data-id="element-773">
                      Sparkling Mineral (Pellegrino-Style)
                    </td>
                    <td className="p-4 text-center text-base text-gray-900" data-id="element-774">
                      <CheckCircleIcon className="inline text-green-600" size={20} data-id="element-775" />{' '}
                      <span className="text-base text-water-accent" data-id="element-776">
                        Exclusive
                      </span>
                    </td>
                    <td className="p-4 text-center text-base text-gray-900" data-id="element-777">
                      Regular/Acidic
                    </td>
                  </tr>
                  <tr className="border-b border-gray-200" data-id="element-778">
                    <td className="p-4 text-base text-gray-900" data-id="element-779">
                      Health Profile
                    </td>
                    <td className="p-4 text-center text-base text-gray-900" data-id="element-780">
                      Low-acidity
                    </td>
                    <td className="p-4 text-center text-base text-gray-900" data-id="element-781">
                      High acidity
                    </td>
                  </tr>
                  <tr className="border-b border-gray-200 bg-gray-50" data-id="element-782">
                    <td className="p-4 text-base text-gray-900" data-id="element-783">
                      Custom Bottle Printing
                    </td>
                    <td className="p-4 text-center text-base text-gray-900" data-id="element-784">
                      Yes/No cost
                    </td>
                    <td className="p-4 text-center text-base text-gray-900" data-id="element-785">
                      Limited
                    </td>
                  </tr>
                  <tr className="border-b border-gray-200" data-id="element-786">
                    <td className="p-4 text-base text-gray-900" data-id="element-787">
                      Culinary Use
                    </td>
                    <td className="p-4 text-center text-base text-gray-900" data-id="element-788">
                      <CheckCircleIcon className="inline text-green-600" size={20} data-id="element-789" />{' '}
                      <span className="text-base" data-id="element-790">Alkaline-based</span>
                    </td>
                    <td className="p-4 text-center text-base text-gray-900" data-id="element-791">
                      Regular
                    </td>
                  </tr>
                  <tr className="border-b border-gray-200 bg-gray-50" data-id="element-792">
                    <td className="p-4 text-base text-gray-900" data-id="element-793">
                      Coffee/Tea Extraction
                    </td>
                    <td className="p-4 text-center text-base text-gray-900" data-id="element-794">
                      Superior
                    </td>
                    <td className="p-4 text-center text-base text-gray-900" data-id="element-795">
                      Regular
                    </td>
                  </tr>
                  <tr className="border-b border-gray-200" data-id="element-796">
                    <td className="p-4 text-base text-gray-900" data-id="element-797">
                      No microplastics, forever chemicals, or fluoride
                    </td>
                    <td className="p-4 text-center text-base text-gray-900" data-id="element-798">
                      <CheckCircleIcon className="inline text-green-600" size={20} data-id="element-799" />
                    </td>
                    <td className="p-4 text-center text-base text-gray-900" data-id="element-800">
                      <XIcon className="inline text-gray-400" size={20} data-id="element-801" />
                    </td>
                  </tr>
                  <tr className="border-b border-gray-200 bg-gray-50" data-id="element-802">
                    <td className="p-4 text-base text-gray-900" data-id="element-803">Ice Quality</td>
                    <td className="p-4 text-center text-base text-gray-900" data-id="element-804">
                      Crystal-clear
                    </td>
                    <td className="p-4 text-center text-base text-gray-900" data-id="element-805">
                      Regular
                    </td>
                  </tr>
                  <tr className="border-b border-gray-200" data-id="element-806">
                    <td className="p-4 text-base text-gray-900" data-id="element-807">
                      Menu Integration
                    </td>
                    <td className="p-4 text-center text-base text-gray-900" data-id="element-808">
                      Alkaline
                    </td>
                    <td className="p-4 text-center text-base text-gray-900" data-id="element-809">
                      Regular
                    </td>
                  </tr>
                  <tr className="border-b border-gray-200 bg-gray-50" data-id="element-810">
                    <td className="p-4 text-base text-gray-900" data-id="element-811">
                      Instant Near-Boiling Hot Water
                    </td>
                    <td className="p-4 text-center text-base text-gray-900" data-id="element-812">
                      <CheckCircleIcon className="inline text-green-600" size={20} data-id="element-813" />
                    </td>
                    <td className="p-4 text-center text-base text-gray-900" data-id="element-814">
                      <XIcon className="inline text-gray-400" size={20} data-id="element-815" />
                    </td>
                  </tr>
                  <tr className="border-b border-gray-200" data-id="element-816">
                    <td className="p-4 text-base text-gray-900" data-id="element-817">
                      Unlimited Instant Sparkling Water
                    </td>
                    <td className="p-4 text-center text-base text-gray-900" data-id="element-818">
                      <CheckCircleIcon className="inline text-green-600" size={20} data-id="element-819" />
                    </td>
                    <td className="p-4 text-center text-base text-gray-900" data-id="element-820">
                      <XIcon className="inline text-gray-400" size={20} data-id="element-821" />
                    </td>
                  </tr>
                  <tr className="border-b border-gray-200 bg-gray-50" data-id="element-822">
                    <td className="p-4 text-base text-gray-900" data-id="element-823">
                      Autofill Tech that Fills Bottles Hands-Free
                    </td>
                    <td className="p-4 text-center text-base text-gray-900" data-id="element-824">
                      <CheckCircleIcon className="inline text-green-600" size={20} data-id="element-825" />
                    </td>
                    <td className="p-4 text-center text-base text-gray-900" data-id="element-826">
                      Some
                    </td>
                  </tr>
                  <tr className="border-b border-gray-200" data-id="element-827">
                    <td className="p-4 text-base text-gray-900" data-id="element-828">
                      No sitting water where bacteria or rust can form
                    </td>
                    <td className="p-4 text-center text-base text-gray-900" data-id="element-829">
                      <CheckCircleIcon className="inline text-green-600" size={20} data-id="element-830" />
                    </td>
                    <td className="p-4 text-center text-base text-gray-900" data-id="element-831">
                      <XIcon className="inline text-gray-400" size={20} data-id="element-832" />
                    </td>
                  </tr>
                  <tr className="border-b border-gray-200 bg-gray-50" data-id="element-833">
                    <td className="p-4 text-base text-gray-900" data-id="element-834">Technology</td>
                    <td className="p-4 text-center text-base text-gray-900" data-id="element-835">
                      AI + Auto-Clean
                    </td>
                    <td className="p-4 text-center text-base text-gray-900" data-id="element-836">
                      Basic
                    </td>
                  </tr>
                  <tr className="border-b border-gray-200" data-id="element-837">
                    <td className="p-4 text-base text-gray-900" data-id="element-838">Lease Price</td>
                    <td className="p-4 text-center text-base text-gray-900" data-id="element-839">
                      $299
                    </td>
                    <td className="p-4 text-center text-base text-gray-900" data-id="element-840">
                      $250–350/mo
                    </td>
                  </tr>
                  <tr className="bg-gray-50" data-id="element-841">
                    <td className="p-4 text-base text-gray-900" data-id="element-842">
                      Overall Value
                    </td>
                    <td className="p-4 text-center text-base text-gray-900" data-id="element-843">
                      ⭐ Highest
                    </td>
                    <td className="p-4 text-center text-base text-gray-900" data-id="element-844">
                      Regular
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      {/* Profit Calculator Section */}
      <div className="py-20 md:py-32 bg-gray-50" data-id="element-845">
        <div className="container mx-auto px-4 md:px-6 lg:px-12" data-id="element-846">
          <div className="max-w-6xl mx-auto" data-id="element-847">
            <RestaurantProfitCalculator data-id="element-848" />
          </div>
        </div>
      </div>

      {/* Optional Add-On — JuLi™ System */}
      <div className="py-20 md:py-32 bg-gray-50" data-id="element-849">
        <div className="container mx-auto px-4 md:px-6 lg:px-12" data-id="element-850">
          <div className="max-w-4xl mx-auto" data-id="element-851">
            <div className="bg-white p-8 md:p-12 rounded-2xl shadow-xl" data-id="element-852">
              <h2 className="text-3xl md:text-5xl font-light mb-6" data-id="element-853">
                Optional Add-On — JuLi™ System
              </h2>
              <p className="text-lg text-gray-600 mb-8" data-id="element-854">
                JuLi™ offers a complete beverage platform that pairs perfectly
                with WELLHAUS™:
              </p>

              <div className="grid md:grid-cols-2 gap-8 items-center" data-id="element-855">
                <div data-id="element-856">
                  <h3 className="text-xl font-medium mb-4" data-id="element-857">Features:</h3>
                  <ul className="space-y-3 text-gray-700 mb-6" data-id="element-858">
                    <li className="flex items-start gap-3" data-id="element-859">
                      <CheckCircleIcon size={20} className="flex-shrink-0 text-water-accent mt-1" data-id="element-860" />
                      <span data-id="element-861">Alkaline Water</span>
                    </li>
                    <li className="flex items-start gap-3" data-id="element-862">
                      <CheckCircleIcon size={20} className="flex-shrink-0 text-water-accent mt-1" data-id="element-863" />
                      <span data-id="element-864">Sparkling Mineral Water</span>
                    </li>
                    <li className="flex items-start gap-3" data-id="element-865">
                      <CheckCircleIcon size={20} className="flex-shrink-0 text-water-accent mt-1" data-id="element-866" />
                      <span data-id="element-867">6 Flavors (soda, diet, juice, flavored water)</span>
                    </li>
                    <li className="flex items-start gap-3" data-id="element-868">
                      <CheckCircleIcon size={20} className="flex-shrink-0 text-water-accent mt-1" data-id="element-869" />
                      <span data-id="element-870">Smart micro-dosing</span>
                    </li>
                    <li className="flex items-start gap-3" data-id="element-871">
                      <CheckCircleIcon size={20} className="flex-shrink-0 text-water-accent mt-1" data-id="element-872" />
                      <span data-id="element-873">High-capacity cooling</span>
                    </li>
                  </ul>

                  <h3 className="text-xl font-medium mb-4" data-id="element-874">Ideal For:</h3>
                  <p className="text-gray-700 mb-4" data-id="element-875">
                    Flavored water, functional hydration, soda, and juice-style
                    beverages.
                  </p>
                  <p className="text-gray-700 font-medium" data-id="element-876">
                    Can be paired with WELLHAUS™ for a full hydration platform.
                  </p>
                </div>

                <div className="relative h-[400px] rounded-xl overflow-hidden shadow-lg" data-id="element-877">
                  <img src="https://cdn.magicpatterns.com/uploads/15ReUcFuSc8MYZsBEXiFai/JuLi™_System.webp" alt="JuLi System in elegant restaurant setting" className="w-full h-full object-cover" data-id="element-878" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* CTA Section */}
      <div className="text-white py-20 md:py-32" style={{
      backgroundColor: '#1a2332'
    }} data-id="element-879">
        <div className="container mx-auto px-4 md:px-6 lg:px-12 text-center" data-id="element-880">
          <h2 className="text-4xl md:text-6xl font-light mb-6" data-id="element-881">
            Upgrade to the Most Advanced Water System on the Market
          </h2>
          <p className="text-xl text-gray-300 mb-10 max-w-2xl mx-auto" data-id="element-882">
            Only WELLHAUS offers Still, Sparkling, Alkaline, and Sparkling
            Mineral (Pellegrino-Style) water — plus custom bottles and full
            Section 179 benefits.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-883">
            <a href="https://form.typeform.com/to/rfYM00cT" target="_blank" rel="noopener noreferrer" className="px-10 py-4 bg-white text-gray-900 text-base font-medium rounded-full hover:bg-gray-100 transition-colors" data-id="element-884">
              Request a Demo
            </a>
            <a href="https://calendly.com/-smartsoda/discoverycall" target="_blank" rel="noopener noreferrer" className="px-10 py-4 border border-white text-white text-base font-medium rounded-full hover:bg-white hover:text-gray-900 transition-colors" data-id="element-885">
              Contact Sales
            </a>
          </div>
        </div>
      </div>
    </div>;
}